import React 			from 'react';
import PropTypes 		from 'prop-types';
import BLComponent 		from '../core/_BLComponent.jsx';

import videojs from 'video.js';
import 'video.js/dist/video-js.css';


export default class StudioDownloadHeader extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
			
		}
	}

	componentDidMount() {
		const playerProps = {
			autoplay: true,
			playsinline: true,
			muted: true,
			controls: true,
			loop: true,
			controlBar: {
					'pictureInPictureToggle': false,
					'volumePanel': false,
					'fullscreenToggle': false
			},
			aspectRatio: '16:9',
			sources: [{
				src: '//cache2.bricklink.info/img/studio-download/studio-hero-vid.mp4',
				type: 'video/mp4'
			}]
		};

    this.player = videojs(this.videoNode, playerProps, () => {
      // videojs.log('onPlayerReady', this);
			updateText(0);
    });
		
		// updateText = (time) => this.updateText(time);

		this.player.on('timeupdate', function() {
			updateText(this.currentTime());
		})
  }

	render() {
		return (
			<section className="container studio-download__header-container">
				<div className="container__internal l-pad-x studio-download__header studio-download__main-header">
					<div className="studio-download__main-header-text studio-download__main-header-text--studio">
						<h1 className="studio-download__header-title studio-download__header-title--studio" id="js-studio-title" style={{color:'#42C0FB'}}></h1>
						<h2 className="studio-download__header-sub-title studio-download__header-sub-title--studio text--bold">in Studio</h2>
						<p className="text--small-title">Digital brick building software, powered by the LEGO Group.</p>
						{this.props.children}
					</div>
					<div className="studio-download__hero-video l-border-round overflow-hidden">
						<div data-vjs-player>
							<video ref={node => this.videoNode = node} className="video-js"></video>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

const words = [
	{word: 'Build', color: '#42C0FB', timestamp: 1}
, {word: 'Render', color: '#72C850', timestamp: 12.15}//12.15
, {word: 'Instructions', color: '#F7D117', timestamp: 17.16}
];

let title;

let wordIndex = 0;
let started = false;
let wordTypeTimeout;
let wordDeleteTimeout;
let letterIndex = 0;

function updateText(time) {
	title = document.getElementById('js-studio-title');
	// console.log(time);

	if(started == false) {
		deleteWordContent();

		started = true;
	}

	if(time > words[2].timestamp) {
		if(wordIndex !== 2) {
			deleteWordContent();
		}

		wordIndex = 2;
	}else if(time > words[1].timestamp) {
		if(wordIndex !== 1) {
			deleteWordContent();
		}

		wordIndex = 1;
	}else{
		if(wordIndex !== 0) {
			deleteWordContent();
		}

		wordIndex = 0;
	}
}

function updateWordContent() {
	title.style.color = words[wordIndex].color;
	title.style.borderColor = words[wordIndex].color;
	
	writeWordContent(wordIndex);
}

function writeWordContent(idx) {
	const wordLength = words[idx].word.length;
	
	if(letterIndex == wordLength) {
		clearTimeout(wordTypeTimeout);
		return;
	}else{
		title.innerHTML = title.innerHTML + words[idx].word[letterIndex];
		letterIndex++;
		wordTypeTimeout = setTimeout(() => writeWordContent(idx), Math.floor(Math.random() * 150) + 75);
	}
}

function deleteWordContent() {
	const wordLength = title.innerHTML.length;
	
	if(wordLength == 0) {
		clearTimeout(wordDeleteTimeout);
		letterIndex = 0;
		updateWordContent();
	}else{
		title.innerHTML = title.innerHTML.slice(0, -1);
		wordDeleteTimeout = setTimeout(deleteWordContent, Math.floor(Math.random() * 150) + 75);
	}
}
	